<template>
<div>

<div class="card border-warning" >
  <div class="card-header bg-transparent border-success ">
    <h4 style="color:brown">
    <i style="color:brown" class="fas fa-ruler-combined mr-2" aria-hidden="true"></i>
    <strong>
      
      TABELLA MISURE GIA' UTILIZZATE</strong></h4> 
       <button class="btn btn-sm ml-3"  @click="$emit('swap')"> MOSTRA TUTTE LE MISURE </button>  
  </div>
  <div class="card-body">

  <div v-if="!spinner" class="table-responsive">
   <table class="table table-sm" id="table">
    <thead>
      <tr>
        <th v-for="(col,index) in filteredSizes" :key="index">
          <p class="btn btn-outline_ text-nowrap" type="button" @click="provide(col)" 
          
          v-bind:class="{ active : check(candidates,col) == 1 ,no_active : check(candidates,col) == 2  }">{{col.size}}</p>          
          
        </th>
      </tr>
    </thead>
  </table>
  </div>
  <div v-else>
    <div class="spinner-grow spinner-grow-sm text-warning"   role="status">
        <span class="sr-only">Loading...</span>
    </div>
  </div>  

<!-- BODY CARD -->
</div>

</div>

<small  id="sizeHelp" class="form-text text-muted"><strong>Selezionare una misura dall'elenco.</strong></small>    
<strong>Filtra misura</strong> 
<input id="cerca" class="form-control" type="text" name="query" v-model="filterKey">   
</div>
</template>

<script>
import { mapGetters }      from 'vuex';
import api from '@/api'

  export default {
    props:['selection'],
    
    data () {
      return {
        
        cols         : [], 
        candidates   : [],
        spinner      : false,
        filterKey    : ''

        
      }
    },
  
    computed: 
  {
    ...mapGetters(['company']) , 
    filteredSizes : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.cols
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            if(key=='size')
            {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            }
          })
        })
      }
        return items
     },
  },

    created () 
    {
      this.getData()
    },

    methods: 
    {
    
    provide: function(col)
    {
       
       // OLD SIZE 
       if(this.selection.filter(item => item.sizeId == col.sizeId && item.newSize == 'N').length > 0 )        
       {
       
         return
       }

      col.selected = col.selected == 0 ? 1 : 0
      
      

      if(this.candidates.indexOf(col.sizeId) == -1)
      {
        

      	this.candidates.push(col.sizeId)
      }
      else
      {
      	this.candidates.splice(this.candidates.indexOf(col.sizeId), 1);
      }
    
      this.sendMessage()
     
    },

    check : function(arr, item)
    {


      if(this.selection.filter(row=>row.sizeId == item.sizeId && row.newSize=='N').length > 0)
      {
        
        return 1
      }

      if(arr.indexOf(item.sizeId) != -1 && item.selected==1)
      {
        
        return 2
      }
      
      return 3
      

     },

     
 
      
      sendMessage() 
      {
        
        var sizes = []
        this.cols.forEach(item=>{
          if(item.selected == 1)
          {

            let item_active = this.selection.filter(row => row.sizeId == item.sizeId && row.newSize == 'N')
            
            if(item_active.length > 0)
            {
              item.newSize = 'N'
            }
            sizes.push(item)
          }
        })
        
       

        this.$emit('update',sizes)
        

      },  
      async getData()
      {
        this.spinner = true
        var data     = {"companyId" : this.company.Id}  
        var sp       = {'sp'        : 'spCompanySizeList'}
        var json     = Object.assign(data, sp)

        await api.post(json).then(res => {
          if(res.status==200)
            {

            this.cols = res.data.recordsets[0]
            
            this.selection.forEach(item=>{

              this.cols.forEach(col=>{
                if(item.sizeId == col.sizeId)
                {
                  col.selected = 1
                  this.candidates.push(item.sizeId)
                }
              })    
            })
                     
            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.spinner = false
        });
        
      },  

    }
  }
</script>
<style scoped>

.no_active {
  color             : black;
  background-color  : #ffc107;
}
.active {

  color             : white;
  background-color  : chocolate;
}

p {
  font-family    : 'Roboto Condensed';
  font-size      : 18px;
}

tr:hover {
   cursor        : pointer;
  }

 
 .my-custom-scrollbar {
    position  : relative;
    height    : 400px;
    overflow  : auto;
    }
  .table-wrapper-scroll-y {
    display   : block;
  }
 
  h4 {
  font-family : 'Roboto Condensed';
  font-size   : 16px;
}
button 
{
  background-color: teal;
  color           : white;

}
button:hover {
  color: yellow;
}

</style>
